import { takeLatest } from 'redux-saga/effects';
import { UPDATE_PARAMETER, GET_PARAMETERS } from './constants';
import { updateParameterAction } from './actions/updateParameter';
import { indexParametersAction } from './actions/indexParameters';

export default [
  takeLatest(UPDATE_PARAMETER, updateParameterAction),
  takeLatest(GET_PARAMETERS, indexParametersAction),
];
